import { Component, Injector } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { RepeaterService } from '../../service/repeater-service/repeater.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-bulk-repeater-type',
  templateUrl: './bulk-repeater-type.component.html',
  styleUrl: './bulk-repeater-type.component.scss'
})
export class BulkRepeaterTypeComponent extends FieldArrayType {
  uuid = uuidv4();
  hide: boolean = false;
  hasSelectedData: boolean = false;

  constructor(private injector: Injector) {
    super();
    this.injector.get(RepeaterService).setRepeater(this.uuid, this);

  };

  checkSelectedData(){

const hasNonEmptyNestedItem = Object.values(this.formControl.controls).some((control: any) => {
  const value = control.value;
  return (value?.selected?.length > 0) || (value?.term?.includes('|'));
});

    this.hasSelectedData = hasNonEmptyNestedItem;

  }

  subscribeNonSubcribedChildrenControls() {
    this.field.fieldGroup?.forEach((childField: any) => {
      const control = childField.formControl;
      if (control && (!childField['subscribed'] || childField['subscribed'] == false)) {
          control.valueChanges.subscribe((value: any) => {
                childField['subscribed'] = true;
                this.checkSelectedData();
                this.updateCheckbox();  
          });
        }
    });

  }
  ngOnInit() {
    this.hide = this.props.hidden || this.hide;
    this.field.props = { ...this.field.props, repeaterId: this.uuid };
    this.initializeRepeaterChildrenComponent();
    this.subscribeNonSubcribedChildrenControls();
    this.checkSelectedData();
    this.expandCheckbox();
  }
  
  ngOnDestroy(): void {
    this.injector.get(RepeaterService).clearRepeater(this.uuid);
  }

  updateCheckbox(){
    if (this.hasSelectedData) {
      this.field.formControl!.parent!.get!('filterStatus')!.setValue(this.hasSelectedData);
    } 
  }

  getFilterFontStatus(){
    return (this.hasSelectedData && !this.field.parent!.model.filterStatus)?'filter-disabled-font': 'filter-enabled-font';
  }

  getStatus() {
    this.field.parent!.model.hasSelectedData = this.hasSelectedData;
    const status = this.hasSelectedData?'field-filtered':'field-notSelected';
    
    return status
  }

  conmuteHide() {
    this.hide = (this.props.hidden == true) && !this.hide;
  }

  initializeRepeaterChildrenComponent(){
      const pendingGroup = this.field.fieldGroup?.find(group => {
      const componentField = group.fieldGroup?.find(f => f.key === 'componentID');
      return componentField?.formControl?.value === 'pending_init';
    });

    if (pendingGroup) {
      const componentField = pendingGroup.fieldGroup?.find(f => f.key === 'componentID');
      const newId = uuidv4();
      componentField?.formControl?.setValue(newId);
    }

  }

  override add() {
    super.add();
    this.initializeRepeaterChildrenComponent();

    this.subscribeNonSubcribedChildrenControls();
  }

  expandCheckbox() {
    const controlStatus = this.field.parent!.get!('filterStatus').formControl;
    if (controlStatus) {
      controlStatus.valueChanges.subscribe((value) => {
        if (value == true) {
          this.hide = false; 
        } else {
          this.hide = true;
        }
      });
    }
  }
}
